<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2 visitor-profile-page">
    <div class="calls row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-2 full-width">Visitor Profile</h2>
        <router-link :to="{ name: 'visitor-management' }" class="d-inline-block mb-2">
          &laquo; Back to visitor management
        </router-link>

        <section v-if="!loading">
          <section>
            <div class="row">
              <div class="col-sm-6">
                <visitor-details :visitor_user_id="$route.params.id"></visitor-details>
              </div>
              <div class="col-sm-6">
                <visitors-contacts :visitor_user_id="$route.params.id"></visitors-contacts>
                <additional-visitors :show-add-btn="false" :show-remove-btn="false"></additional-visitors>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <visitors-purple-phone-contacts :visitor_user_id="$route.params.id"></visitors-purple-phone-contacts>
                <visitors-previous-visits :visitor_user_id="$route.params.id"></visitors-previous-visits>
                <visitors-previous-social-visits :visitor-user-id="$route.params.id" />
                <purple-calls-table :visitor_user_id="$route.params.id"/>
                <visitor-bans :editable="true" :visitor_user_id="$route.params.id"></visitor-bans>
                <visitor-social-bans :editable="true" :visitor_user_id="$route.params.id" />
              </div>
            </div>
          </section>
        </section>

        <b-spinner class="d-block" v-else variant="primary"></b-spinner>
      </div>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import VisitorDetails from '@/components/visitors/details/VisitorDetails';
import VisitorBans from '@/views/bans/VisitorBans';
import VisitorsPreviousVisits from '@/views/visitorDetails/VisitorsPreviousVisits';
import AdditionalVisitors from '@/views/calls/callDetails/sections/AdditionalVisitors';
import VisitorsContacts from '@/components/contacts/VisitorsContacts';
import VisitorsPurplePhoneContacts from '@/components/contacts/VisitorsPurplePhoneContacts';
import PurpleCallsTable from '@/components/purpleCalls/PurpleCallsTable';
import VisitorSocialBans from "@/views/socialBans/VisitorSocialBans.vue";
import VisitorsPreviousSocialVisits from "@/components/socialVisits/VisitorPreviousSocialVisits.vue";

export default {
  name: 'VisitorProfile',
  components: {
    VisitorsPreviousSocialVisits,
    VisitorSocialBans,
    VisitorDetails,
    VisitorBans,
    VisitorsPreviousVisits,
    AdditionalVisitors,
    VisitorsContacts,
    VisitorsPurplePhoneContacts,
    PurpleCallsTable,
  },
  props: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      visitor: state => state.visitor.visitor,
    }),
  },
  mounted() {
    this.getVisitor();
  },
  methods: {
    async getVisitor() {
      this.loading = true;
      await this.$store.dispatch('prison/getPrison');
      await this.$store.dispatch('callDetails/getAdditionalVisitorsForProfile', this.$route.params.id);
      // Finished loading
      this.loading = false;
    },
  },
}
</script>
